// extracted by mini-css-extract-plugin
export default {"table":"OrderHistory_table__fFlr+","icons":"OrderHistory_icons__9tV1K","pending":"OrderHistory_pending__0aro5","delivered":"OrderHistory_delivered__HQenQ"};